module.exports = __webpack_public_path__ + "img/icon-02.9f46fa0e.png";